import styled from "styled-components"

import { Span } from "./span"

export const Title = styled(Span).attrs(() => ({ as: "h1" }))`
  font-family: Merriweather, sans-serif;
  font-size: ${(props) => (props.size ? props.size : "24px")};
  font-weight: ${(props) => (props.weight ? props.weight : "bold")};
`

export default Title
